module.exports = __webpack_public_path__ + "assets/certificate_pdf/Artificial Intelligence Knowledge Today_Silicon Stone Education_2019-10-02.4d3c6e2d.pdf";